// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Added in version 1.11.0
 */
export enum SpeechSynthesisOutputFormat {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */
    Raw8Khz8BitMonoMULaw,

    /**
     * riff-16khz-16kbps-mono-siren
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */
    Riff16Khz16KbpsMonoSiren ,

    /**
     * audio-16khz-16kbps-mono-siren
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */
    Audio16Khz16KbpsMonoSiren,

    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */
    Audio16Khz32KBitRateMonoMp3,

    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */
    Audio16Khz128KBitRateMonoMp3,

    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */
    Audio16Khz64KBitRateMonoMp3,

    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */
    Audio24Khz48KBitRateMonoMp3,

    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */
    Audio24Khz96KBitRateMonoMp3,

    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */
    Audio24Khz160KBitRateMonoMp3,

    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */
    Raw16Khz16BitMonoTrueSilk,

    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */
    Riff16Khz16BitMonoPcm,

    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */
    Riff8Khz16BitMonoPcm,

    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */
    Riff24Khz16BitMonoPcm,

    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */
    Riff8Khz8BitMonoMULaw,

    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */
    Raw16Khz16BitMonoPcm,

    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */
    Raw24Khz16BitMonoPcm,

    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */
    Raw8Khz16BitMonoPcm,

    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */
    Ogg16Khz16BitMonoOpus,

    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */
    Ogg24Khz16BitMonoOpus,

    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */
    Raw48Khz16BitMonoPcm,

    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */

    Riff48Khz16BitMonoPcm,
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */
    Audio48Khz96KBitRateMonoMp3,

    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */
    Audio48Khz192KBitRateMonoMp3,
}
